import { render, staticRenderFns } from "./VisitDetailField.vue?vue&type=template&id=497abf14&"
import script from "./VisitDetailField.ts?vue&type=script&lang=ts&"
export * from "./VisitDetailField.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports